import type { IFormxRepository, FieldUpdateInput } from '../repositories/IFormxRepository.js';
import type { FormxFieldEntity } from '../entities/FormxEntity.js';

export interface UpdateFormxFieldInput { id: string; data: FieldUpdateInput; }
interface Deps { formxRepository: IFormxRepository; }

export function createUpdateFormxFieldUseCase({ formxRepository }: Deps) {
  return async function updateFormxField({ id, data }: UpdateFormxFieldInput): Promise<FormxFieldEntity | null> {
    return formxRepository.updateField(id, data);
  };
}
